import { combineReducers } from 'redux';
import socketEvents from './socketEvents';

export default combineReducers({
    socketEvents,
});